import CombinedRuleTemplateModel from "./CombinedRuleTemplateModel.js";

/**
 * Gather the 2 rule template models required for the RuleTemplatesWidget.
 *
 * @param {AbstractRuleTemplateModel} predictionRuleTemplateModel - Rule template model
 *   related to the prediction rule.
 * @param {AbstractRuleTemplateModel} balanceRuleTemplateModel - Rule template model
 *   related to the balance rule.
 */
export default class RuleTemplatesModel extends CombinedRuleTemplateModel {
	constructor({ predictionRuleTemplateModel, balanceRuleTemplateModel }) {
		super({
			models: [predictionRuleTemplateModel, balanceRuleTemplateModel],
		});

		this._predictionRuleTemplateModel = predictionRuleTemplateModel;
		this._balanceRuleTemplateModel = balanceRuleTemplateModel;
	}

	isEmpty() {
		return this._models.every((model) => model.isNoRule());
	}

	getPredictionRuleTemplateModel() {
		return this._predictionRuleTemplateModel;
	}

	getPredictionRuleTemplateLabel() {
		return this._predictionRuleTemplateModel.getLabel();
	}

	getBalanceRuleTemplateModel() {
		return this._balanceRuleTemplateModel;
	}

	getPredictionRuleModel() {
		return this._predictionRuleTemplateModel.getRuleModel();
	}

	setPredictionRuleModel(ruleModel) {
		return this._predictionRuleTemplateModel.setRuleModel(ruleModel);
	}

	setPredictionForm(form) {
		this._predictionRuleTemplateModel.setForm(form);
	}

	getBalanceRuleModel() {
		return this._balanceRuleTemplateModel.getRuleModel();
	}

	setBalanceForm(form) {
		this._balanceRuleTemplateModel.setForm(form);
	}

	isBeta() {
		return this._predictionRuleTemplateModel.isBeta();
	}
}
